import type { Config } from 'tailwindcss';
import colors from 'tailwindcss/colors';
import plugin from 'tailwindcss/plugin';
import * as Components from './../css/components';
import * as DynamicUtility from './../css/dynamic-utilities';
import * as StaticUtility from './../css/static-utilities';
import configCoreComponents from '@tui-cruises/mein-schiff-web-tailwind-config/dist/src/tailwind-config';
import { semantic } from '../colors';

export const config: Config = {
  content: [],
  presets: [
    {
      ...configCoreComponents,
      plugins: [],
      content: [],
    },
  ],
  theme: {
    // TODO Muss in configCoreComponents aufgenommen werden
    borderWidth: {
      ...configCoreComponents.theme?.borderWidth,
      0: '0',
    },
    // TODO Muss in configCoreComponents aufgenommen werden
    lineHeight: {
      ...configCoreComponents.theme?.lineHeight,
      none: '1',
    },
    borderRadius: {
      ...configCoreComponents.theme?.borderRadius,
      xs: '.125rem',
    },
  },
  extend: {
    fontFamily: {
      mono: 'monospace',
      sans: ['var(--font-source-sans)'],
    },
    colors: {
      inherit: colors.inherit,
      current: colors.current,
      transparent: colors.transparent,
    },
    animation: {
      'scroll-indicator':
        'scroll-indicator 1s cubic-bezier(.37,.81,.3,1.01) 1s infinite alternate',
    },
  },
  future: {
    hoverOnlyWhenSupported: true,
  },
  plugins: [
    require('tailwindcss-animate'),
    require('tailwind-gradient-mask-image'),
    require('@tailwindcss/container-queries'),
    plugin(api => {
      api.addUtilities(Object.values(StaticUtility));

      Object.values(DynamicUtility).forEach(utility => utility(api));

      api.addComponents(
        Object.values(Components).map(component => {
          return typeof component === 'function' ? component(api) : component;
        }),
      );

      api.addComponents({
        '.cf-rich-text': {
          fontSize: '1.125rem',
          lineHeight: '1.6',
          color: semantic.text['high-emphasis'],
        },
      });
    }),

    plugin(({ addVariant, matchVariant }) => {
      // firefox only modifier
      addVariant('firefox', ':-moz-any(&)');

      // Modifiers for interactive (= clickable) elements & their group's descendants
      addVariant('interactive', ['a&', 'button&']);
      matchVariant(
        'group-interactive-hover',
        (_, { modifier }) => {
          return [
            `a:merge(.group${modifier ? '\\/' + modifier : ''}):hover &`,
            `button:merge(.group${modifier ? '\\/' + modifier : ''}):hover &`,
          ];
        },
        {
          values: { DEFAULT: '' },
        },
      );
    }),
  ],
};
